var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.973,
    height: 22.497,
    viewBox: "0 0 23.973 22.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34166",
    "data-name": "Path 34166",
    d: "M19.359,6.036a7.5,7.5,0,0,0-14.711,0,5.25,5.25,0,0,0,.6,10.466H9A.75.75,0,1,0,9,15H5.253A3.75,3.75,0,1,1,5.3,7.5a.75.75,0,0,0,.745-.668,6,6,0,0,1,11.921,0,.8.8,0,0,0,.79.668,3.75,3.75,0,1,1,0,7.5H15a.75.75,0,1,0,0,1.5h3.75a5.25,5.25,0,0,0,.605-10.461Zm0,0",
    transform: "translate(0.001 0)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34167",
    "data-name": "Path 34167",
    d: "M178.816,216.46l-1.9,1.9v-9.44a.75.75,0,1,0-1.5,0v9.44l-1.9-1.9a.75.75,0,1,0-1.079,1.042l.018.018,3.181,3.182a.752.752,0,0,0,.242.162.741.741,0,0,0,.578,0,.749.749,0,0,0,.242-.162l3.181-3.182a.75.75,0,1,0-1.042-1.079Zm0,0",
    transform: "translate(-164.16 -198.426)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/download-white.887e14485741887c6fd3f65580f4bb94.svg";
export { ForwardRef as ReactComponent };